//TODO: Develop way to retrieve data and stay up to date
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.LightningSource = new Class({
    Extends: OCS.Viewer.Classes.ClusterSource,
    class_name: "LightningSource",
    date_obj: null,
    bound_methods: {},
    options: {
        init: {
            cluster_distance: 7
        },
        metadata: {
            source_type: 'Lightning',
            states: OCS.Viewer.Config.lightning_info.default_states
        },
        reference_coord: [OCS.Viewer.Config.oklahoma_lon, OCS.Viewer.Config.oklahoma_lat],
        reference_dist: 300 // 300 miles
    },
    initialize: function (ops) {
        this.parent(ops);
        // Register the source filters
        var mngr = OCS.Viewer.Functions.get_lightning_manager();
        this.bound_methods.get_data = this.get_data.bind(this);
        this.bound_methods.source_changed = this.source_changed.bind(this);
        mngr.addEvent('lightning_update', this.bound_methods.get_data);
    },
    set_data: function () {
    },
    get_data: function () {
        var mngr = OCS.Viewer.Functions.get_lightning_manager();
        this.process_lightning_data(mngr.get_lightning_features(this.get_dateObj(), this.options.reference_coord, this.options.reference_dist));
    },
    process_lightning_data: function (features) {
        if (features && features.length) {
            var vs_src = this.get_vector_source();
            var ol_source = vs_src.get_source();
            ol_source.clear(true);
            try {
                ol_source.addFeatures(features);
            } catch (err) {
                console.log("Lighting Source: ", err);
            }
            vs_src.features_added();
            this.features_added();
        }
    },
    set_reference_coord: function (lon, lat, map) {
        var coord = [lon, lat];
        this.options.reference_coord = coord;
        this.clear();
        this.get_data();
        this.fireEvent('new_source_reference_coord', [coord, this], 1);
    },
    set_dateObj: function (dateObj) {
        if (!this.date_obj) {
            this.date_obj = dateObj;
            this.date_obj.addEvent('time_update', this.bound_methods.source_changed);
            // Now that we have a datetime obj, go get the data
            this.get_data();
        }
    },
    get_dateObj: function () {
        return this.date_obj;
    },
    get_timestamp_epoch: function () {
        return this.date_obj.get_current_epoch_time();
    },
    destroy_source: function () {
        if (this.date_obj) {
            this.date_obj.removeEvent('time_update', this.bound_methods.source_changed);
        }
        var mngr = OCS.Viewer.Functions.get_lightning_manager();
        mngr.removeEvent('lightning_update', this.bound_methods.get_data);
        this.bound_methods = {};
        this.date_obj = null;
        this.parent();
    }
});
